module.exports = __webpack_public_path__ + "img/hot.567f7c4b.svg";